
// Formati -> varianti Shopify: ogni .fmt porta il variant id in data-vid.
(function(){
  var f=document.querySelectorAll('.pp .fmt'),p=document.querySelector('.pp .price b'),s=document.querySelector('.pp .price s'),
      form=document.getElementById('dp-atc'),idf=form?form.querySelector('[name=id]'):null;
  f.forEach(function(el){el.addEventListener('click',function(){
    f.forEach(function(x){x.classList.remove('on')});el.classList.add('on');
    if(p&&el.dataset.price)p.textContent=el.dataset.price;
    if(s&&el.dataset.compare)s.textContent=el.dataset.compare;
    if(idf&&el.dataset.vid)idf.value=el.dataset.vid;
  });});
})();
